import { fetchCategories, filterOption } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { fetchTags } from "../../../../../tag/services/tag"
import { RenderConfig, ToursCarouselProps } from "./RenderConfig"

const SelectCategory = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const fetchCategory = async () => {
    setLoading(true)

    try {
      const response = await fetchCategories()
      const list = (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
        (category: { id: string; attributes: { name: string } }) => ({
          value: category.id as string,
          label: category.attributes.name,
        }),
      )
      setOptionCategories([{ value: "", label: "All Categories" }, ...list])
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  return (
    <Select
      loading={loading}
      showSearch
      style={{ width: "100%" }}
      placeholder="Select Category"
      filterOption={filterOption}
      options={optionCategories}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

const SelectTag = ({ value, onChange }: any) => {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const run = async () => {
      setLoading(true)
      try {
        const res = await fetchTags({ pageSize: "100" })
        const list = (res as { data: { attributes: { name: string; slug: string } }[] }).data.map(
          (tag: { attributes: { name: string; slug: string } }) => ({
            value: tag.attributes.name,
            label: tag.attributes.name,
          }),
        )
        setOptions(list)
      } catch (e) {
        message.error("Failed to fetch tags. Please try again.")
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [])

  return (
    <Select
      loading={loading}
      showSearch
      style={{ width: "100%" }}
      placeholder="Select Tag"
      filterOption={filterOption}
      options={options}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

export const ToursCarousel: ComponentConfig<ToursCarouselProps> = {
  label: "CaoCao | ToursCarousel",
  fields: {
    tag: {
      label: "Tag",
      type: "custom",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Select tag to filter tour </p>
          <SelectTag {...props} />
        </div>
      ),
    },
    isMostPopular: {
      label: "Is most popular",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    categoryId: {
      type: "custom",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Select category to show tour</p>
          <SelectCategory {...props} />
        </div>
      ),
    },
    title: {
      label: "Title",
      type: "text",
    },
    buttonText: {
      label: "Button Text",
      type: "text",
    },
    buttonUrl: {
      label: "Button URL",
      type: "text",
    },
    autoplay: {
      label: "Autoplay",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    slidesPerView: {
      label: "Slides per view (>=1024px)",
      type: "number",
    },
    spaceBetween: {
      label: "Space between",
      type: "number",
    },
  },
  defaultProps: {
    isMostPopular: false,
  },
  ...RenderConfig,
}
